// src/assertDefinedEx.ts
function assertDefinedEx(expr, messageOrFunc) {
  if (expr !== void 0 && expr !== null) return expr;
  if (typeof messageOrFunc === "function") {
    const errorOrMessage = messageOrFunc(expr);
    throw typeof errorOrMessage === "string" ? new Error(errorOrMessage) : errorOrMessage;
  }
  throw new Error(messageOrFunc);
}

// src/assertEx.ts
function assertEx(expr, messageOrFunc) {
  if (expr) return expr;
  if (typeof messageOrFunc === "function") {
    const errorOrMessage = messageOrFunc(expr);
    throw typeof errorOrMessage === "string" ? new Error(errorOrMessage) : errorOrMessage;
  }
  throw new Error(messageOrFunc);
}
export {
  assertDefinedEx,
  assertEx
};
//# sourceMappingURL=index.mjs.map